import { optionsToStrategy } from '@/common/utils/optionsToStrategy'

const createOptions = (maxValue: number) =>
  Array.from({ length: maxValue }, (_, i) => i + 1).map((i) => ({
    label: i.toString(),
    value: `${i}`,
  }))

const optionsFunction = (maxValue?: number) => createOptions(maxValue || 30)

const defaultOptions = createOptions(30)

Object.setPrototypeOf(optionsFunction, Array.prototype)
Object.assign(optionsFunction, defaultOptions)
Object.defineProperty(optionsFunction, 'length', {
  value: defaultOptions.length,
  writable: false,
})

export const options = optionsFunction as typeof defaultOptions & ((maxValue?: number) => typeof defaultOptions)

export const strategy = optionsToStrategy(defaultOptions)
